module.exports = __webpack_public_path__ + "static/media/Apple-iMac.9077d09e.png";